import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="campaign-preview"
// Re-renders the email preview iframe from the live form state.
export default class extends Controller {
  static targets = ["frame"]
  static values = { url: String }

  connect() {
    this.refresh()
  }

  refresh() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), 350)
  }

  async submit() {
    if (!this.hasFrameTarget) return
    const form = this.element
    const data = new FormData(form)
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: data,
        headers: { "X-CSRF-Token": token, Accept: "text/html" },
        credentials: "same-origin"
      })
      const html = await response.text()
      this.frameTarget.srcdoc = html
    } catch (e) {
      console.warn("Preview failed", e)
    }
  }
}
